import getFilterableMailListContextMenuItems from './getFilterableMailListContextMenuItems';
import { observer } from 'mobx-react-lite';
import { IPoint } from 'office-ui-fabric-react/lib/Utilities';
import * as React from 'react';
import {
    ContextualMenu,
    DirectionalHint,
} from 'office-ui-fabric-react/lib/components/ContextualMenu';
import MailListContextMenuSource from 'owa-mail-list-store/lib/store/schema/MailListContextMenuSource';
import getMailListItemPartContextMenuItems from './getMailListItemPartContextMenuItems';
import { getMoveToPropertiesForContextMenu } from 'owa-mail-movetofolder-view/lib/components/getMoveToMenuProperties';
import { getMailMenuItemShouldShowMap } from 'owa-mail-filterable-menu-behavior';
import { listViewStore } from 'owa-mail-list-store';
import MailListContextMenuType from 'owa-mail-list-store/lib/store/schema/MailListContextMenuType';
import { getCategoryMenuPropertiesForContextMenu } from 'owa-mail-category-view';
export interface MailListItemContextMenuProps {
    anchorPoint: IPoint;
    menuType: MailListContextMenuType;
    menuSource?: MailListContextMenuSource;
    tableViewId: string;
    onDismiss: (ev?: any) => void;
}

const MailListItemContextMenu = observer(function MailListItemContextMenu(
    props: MailListItemContextMenuProps
) {
    const { anchorPoint, menuType, menuSource } = props;
    let menuProps = null;
    const tableView = listViewStore.tableViews.get(props.tableViewId);
    const tableViewId = props.tableViewId;
    const onDismiss = props.onDismiss;

    if (menuType === MailListContextMenuType.All) {
        const defaultProps = {
            shouldFocusOnMount: true,
            target: anchorPoint,
            directionalHint: DirectionalHint.bottomLeftEdge,
            onDismiss: props.onDismiss,
            calloutProps: { preventDismissOnScroll: true }, // Prevent setting scrolltop from reading pane to dismiss the right click context menu
        };
        if (menuSource == MailListContextMenuSource.MailListItem) {
            const selectedRowKeys = [...tableView.selectedRowKeys.keys()];
            menuProps = {
                ...defaultProps,
                items: getFilterableMailListContextMenuItems(
                    selectedRowKeys,
                    tableViewId,
                    onDismiss
                ).filter(item => item.shouldShow()),
            };
        } else {
            menuProps = {
                ...defaultProps,
                items: getMailListItemPartContextMenuItems(
                    listViewStore.expandedConversationViewState.selectedNodeIds,
                    tableViewId,
                    onDismiss
                ),
            };
        }
    } else {
        const defaultProps = {
            shouldFocusOnMount: true,
            target: anchorPoint,
            onDismiss: props.onDismiss,
        };
        if (menuType === MailListContextMenuType.MoveTo) {
            const shouldShowBehaviorMap = getMailMenuItemShouldShowMap();
            menuProps = {
                ...defaultProps,
                ...getMoveToPropertiesForContextMenu(
                    tableViewId,
                    onDismiss,
                    'Keyboard',
                    shouldShowBehaviorMap,
                    DirectionalHint.rightTopEdge,
                    null,
                    true
                ),
            };
        } else if (menuType === MailListContextMenuType.Categorize) {
            menuProps = {
                ...defaultProps,
                ...getCategoryMenuPropertiesForContextMenu(
                    tableViewId,
                    onDismiss,
                    'Keyboard',
                    true
                ),
            };
        }
        menuProps.directionalHintFixed = false;
    }

    return <ContextualMenu {...menuProps} />;
});
export default MailListItemContextMenu;
